import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { NavigationLink } from "./NavigationLink";
import { signIn, signOut } from "next-auth/react";
import { useAuth } from "../../Auth/AuthContext";
import { AddIcon, Divider, IconButton, ImageOutlineIcon, InboxOutlineIcon, LocationMarkerOutlineIcon, LogoutOutlineIcon, MapPinIllustration, Navigation, SearchOutlineIcon, SettingsOutlineIcon, TapeOutlineIcon, UserIcon, UserOutlineIcon, VideoCameraOutlineIcon } from "@parkschannel/ui";
import { useAnalytics } from "../../../utils";
import Link from "next/link";
export function AppNavigation(param) {
    let { isOpen  } = param;
    const { onButtonClick  } = useAnalytics();
    const { useSession  } = useAuth();
    const { data: session  } = useSession();
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("pt-[84px] fixed top-0 bottom-0 left-0 right-0 bg-white transition md:pt-0 md:transition-none md:static lg:mr-4", {
            "-translate-x-[100%] md:translate-x-0": !isOpen
        }),
        children: /*#__PURE__*/ _jsxs(Navigation, {
            className: "overflow-y-auto h-full md:h-auto md:overflow-y-visible",
            children: [
                /*#__PURE__*/ _jsx(AppNavigationItem, {
                    icon: /*#__PURE__*/ _jsx(LocationMarkerOutlineIcon, {
                        className: "w-5 h-5"
                    }),
                    href: "/parks",
                    className: "block md:hidden",
                    onClick: ()=>onButtonClick("exploreOurCommunity"),
                    children: "Find your Park"
                }),
                /*#__PURE__*/ _jsxs(Link, {
                    href: "/parks",
                    onClick: ()=>onButtonClick("findYourPark"),
                    className: "hidden mb-4 items-center justify-center flex-row gap-1 text-sm bg-neutral-50 py-2 pl-2 pr-3 rounded-xl text-primary-600 font-bold border-[1px] border-neutral-100 md:flex md:mb-0 md:pr-2 md:flex-col lg:flex-row lg:pr-3",
                    children: [
                        /*#__PURE__*/ _jsx(MapPinIllustration, {
                            className: "w-4 h-4"
                        }),
                        "Find your Park"
                    ]
                }),
                /*#__PURE__*/ _jsx(AppNavigationItem, {
                    icon: /*#__PURE__*/ _jsx(UserIcon, {
                        className: "w-5 h-5"
                    }),
                    href: "/community",
                    onClick: ()=>onButtonClick("exploreOurCommunity"),
                    children: "Community"
                }),
                /*#__PURE__*/ _jsx(AppNavigationItem, {
                    icon: /*#__PURE__*/ _jsx(VideoCameraOutlineIcon, {}),
                    href: "/popular/videos",
                    onClick: ()=>onButtonClick("watchPopularVideosNavigation"),
                    children: "Watch"
                }),
                /*#__PURE__*/ _jsx(AppNavigationItem, {
                    icon: /*#__PURE__*/ _jsx(SearchOutlineIcon, {}),
                    href: "/explore-parks",
                    onClick: ()=>onButtonClick("exploreParksNavigation"),
                    children: "Explore"
                }),
                /*#__PURE__*/ _jsx(AppNavigationItem, {
                    icon: /*#__PURE__*/ _jsx(InboxOutlineIcon, {}),
                    href: "/trip-planner",
                    onClick: ()=>onButtonClick("tripPlannerNavigation"),
                    children: "Plan"
                }),
                /*#__PURE__*/ _jsx(AppNavigationItem, {
                    icon: /*#__PURE__*/ _jsx(AddIcon, {
                        className: "lg:text-neutral-700"
                    }),
                    href: !session ? "/utilities/guidelines/" : "/videos/new",
                    className: "shadow-none lg:border-2 lg:border-primary-500 lg:rounded-xl lg:gap-4 lg:px-6 lg:text-neutral-600 lg:shadow-lg lg:hover:border-primary-400 lg:hover:shadow-xl lg:hover:no-underline lg:transition",
                    onClick: ()=>onButtonClick("submitVideoNavigation"),
                    children: "Submit a video"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "md:hidden",
                    children: [
                        /*#__PURE__*/ _jsx(AppNavigationItem, {
                            icon: /*#__PURE__*/ _jsx(TapeOutlineIcon, {}),
                            href: "/for-creators",
                            onClick: ()=>onButtonClick("becomeCreatorNavigation"),
                            children: "Become a creator"
                        }),
                        /*#__PURE__*/ _jsx(AppNavigationItem, {
                            icon: /*#__PURE__*/ _jsx(ImageOutlineIcon, {}),
                            href: "/about-us",
                            onClick: ()=>onButtonClick("aboutUsNavigation"),
                            children: "About us"
                        }),
                        /*#__PURE__*/ _jsx(MyAccount, {})
                    ]
                })
            ]
        })
    });
}
const AppNavigationItem = (props)=>{
    const { children , className , ...rest } = props;
    return /*#__PURE__*/ _jsx(NavigationLink, {
        disabled: props.disabled,
        onClick: props.onClick,
        className: classNames("mb-2 p-4 md:mr-0 lg:mb-0 lg:mr-1 md:mb-0 md:text-xs md:p-2 md:flex-col lg:flex-row lg:text-sm", {
            "lg:hover:underline": !props.disabled
        }, className),
        ...rest,
        children: children
    });
};
export const MyAccount = (param)=>{
    let { className  } = param;
    const { useSession  } = useAuth();
    const { data: session  } = useSession();
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("mt-12", className),
        children: [
            /*#__PURE__*/ _jsx(Divider, {}),
            /*#__PURE__*/ _jsx("h4", {
                className: "p-4 text-xs text-neutral-900 font-medium",
                children: "My account"
            }),
            session && /*#__PURE__*/ _jsx(MyAccountWithSession, {}),
            !session && /*#__PURE__*/ _jsx(MyAccountWithoutSession, {})
        ]
    });
};
const MyAccountWithSession = ()=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(AppNavigationItem, {
                icon: /*#__PURE__*/ _jsx(SettingsOutlineIcon, {}),
                href: "/users/me",
                children: "Settings"
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                variant: "text",
                position: "left",
                size: "sm",
                icon: /*#__PURE__*/ _jsx(LogoutOutlineIcon, {
                    className: "text-red-500"
                }),
                onClick: ()=>signOut({
                        callbackUrl: "/api/auth/logout"
                    }),
                className: "!px-4 !font-semibold !text-red-500 mt-6",
                children: "Log out"
            })
        ]
    });
};
const MyAccountWithoutSession = ()=>{
    const { onSignIn  } = useAnalytics();
    const handleSignIn = ()=>{
        signIn("cognito");
        onSignIn();
    };
    return /*#__PURE__*/ _jsx(IconButton, {
        variant: "text",
        position: "left",
        size: "sm",
        icon: /*#__PURE__*/ _jsx(UserOutlineIcon, {
            className: "text-primary-600"
        }),
        onClick: handleSignIn,
        className: "!px-4 !font-semibold !text-primary-600 mt-6",
        children: "Sign in / Sign up"
    });
};
